<template>
	<div class="container my-16">
		<div
			class="flex flex-grow overflow-x-scroll hide-scroll mb-10 px-6 lg:px-0"
			data-tab-navigation="bookings"
		>
			<div class="flex flex-nowrap items-center space-x-1">
				<button
					v-for="item in rinks"
					class="tab bg-yellow opacity-50 transition-opacity duration-200 ease-in-out w-auto py-2 px-4 flex-grow-0 flex-shrink-0"
					role="tab"
					:data-tab="item"
					:data-hash="item"
					aria-selected="false"
					:aria-controls="item"
					@click="updateDate"
				>
					Rink {{ item }}
				</button>
			</div>
		</div>
		<div data-tab-content="bookings">
			<div
				class="hidden focus:outline-none flex flex-col flex-grow mt-6"
				:data-content="item"
				:aria-labelledby="item"
				tabindex="0"
				role="tabpanel"
				v-for="item in rinks"
			>
				<h2 class="mb-4">Rink {{ item }}</h2>
				<Calendar ref="contact" :rink="item" :selected="selectedDate" @date="setDate"></Calendar>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue/dist/vue.js";
import { tabNavigation } from "../../modules/tabs";

// Components
import Calendar from "./Calendar.vue";

export default {
	data: function () {
		return {
			rinks: [1, 2, 3, 4, 5, 6],
			selectedDate: new Date(),
		};
	},
	components: {
		Calendar,
	},
	mounted: function () {
		this.$nextTick(function () {
			// Once the instance has been created, we want to run the the tabs script
			tabNavigation();
		});
	},
	watch: {
		selectedDate: {
			handler(newValue, oldValue) {
        		console.log(newValue);
      		},
		}
	},
	methods: {
		updateDate: function() {
			const bookingMonth = localStorage.getItem('bookingMonth');
			if (bookingMonth) {
				this.selectedDate = new Date(bookingMonth);
			}
		},
		setDate: function(date) {
			this.selectedDate = new Date(date);
		}
	}
};
</script>
